module.exports = __webpack_public_path__ + "static/media/decision.6be0b58c.svg";